import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { TextEditor } from "../text-editor";
import { Box, Typography } from "@mui/material";
import ImageUpload from "../common-form/image-common";

const ExportDetailsPage = ({
  handleSubmit,
  initialValues,
  initialData,
  validationSchema,
  imageFolderPath
}) => {
  return (
    <div
      id="kt_app_content"
      className="app-content flex-column-fluid"
      style={{ overflowY: "scroll" }}
    >
      <div
        id="kt_app_content_container"
        className="app-container container-xxl"
        style={{ overflowY: "scroll" }}
      >
        <div className="row gx-5 gx-xl-12 pt-10">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body py-4">
                <Formik
                  initialValues={
                    initialData && initialData?.id ? initialData : initialValues
                  }
                  enableReinitialize={true}
                  onSubmit={handleSubmit}
                  validationSchema={validationSchema}
                >
                  {({ setFieldValue, values,errors }) => {
                    console.log("errors",errors)
                    return (
                      <Form
                        id="kt_ecommerce_settings_general_form"
                        className="form"
                      >
                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                           Hot Rolled Coil
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="hot_rolled"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="hot_rolled" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                             Hot Rolled Coil Image
                            </Typography>
                            <Field
                              name="hot_rolled_image"
                              label="Upload Image"
                              render={({ field, form }) => {
                                return (
                                  <ImageUpload
                                    name={"hot_rolled_image"}
                                    value={values?.semiproductimage}
                                    onChange={setFieldValue}
                                    id={values && values.id}
                                    imageFolderPath={"exports_data"}
                                  />
                                );
                              }}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="hot_rolled_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            Cold Rolled Content
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="cold_rolled"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="cold_rolled" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Cold Rolled Image
                            </Typography>

                            <Field
                              name="cold_rolled_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"cold_rolled_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="cold_rolled_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Hot Dipped
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="hot_dipped"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="hot_dipped" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Hot Dipped Image
                            </Typography>
                            <Field
                              name="hot_dipped_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"hot_dipped_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="hot_dipped_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Aluzinc Steel
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="aluzinc_steel"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="aluzinc_steel" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Aluzinc Steel Image
                            </Typography>

                            <Field
                              name="aluzinc_steel_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"aluzinc_steel_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="aluzinc_steel_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Zinc Aluminum
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="zinc_aluminum"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="zinc_aluminum" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Zinc Aluminum Image
                            </Typography>

                            <Field
                              name="zinc_aluminum_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"zinc_aluminum_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="zinc_aluminum_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Prepainted Content
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="prepainted"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="prepainted" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Prepainted Image
                            </Typography>

                            <Field
                              name="prepainted_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"prepainted_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="prepainted_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Color Coated Content
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="color_coated"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="color_coated" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Color Coated Image
                            </Typography>

                            <Field
                              name="color_coated_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"color_coated_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="color_coated_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Bare Aluminium
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="bare_aluminium"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="bare_aluminium" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Bare Aluminium Image
                            </Typography>

                            <Field
                              name="bare_aluminium_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"bare_aluminium_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="bare_aluminium_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Aluminiumn Coil
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="aluminiumn_coil"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />{" "}
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="aluminiumn_coil" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Aluminiumn Coil Image
                            </Typography>

                            <Field
                              name="aluminiumn_coil_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"aluminiumn_coil_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="aluminiumn_coil_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Aluminiumn
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="aluminium"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />{" "}
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="aluminium" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Aluminiumn Coil Image
                            </Typography>

                            <Field
                              name="aluminium_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"aluminium_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="aluminium_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Wire Rods
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="wire_rods"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="wire_rods" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Wire Rods Image
                            </Typography>

                            <Field
                              name="wire_rods_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"wire_rods_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="wire_rods_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Wire Products Image
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="wire_products"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="wire_products" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Wire Products Image
                            </Typography>

                            <Field
                              name="wire_products_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"wire_products_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="wire_products_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Structural Steel
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="structural_steel"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="structural_steel" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Structural Steel Image
                            </Typography>

                            <Field
                              name="structural_steel_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"structural_steel_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="structural_steel_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Pipe Products
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="pipe_products"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="pipe_products" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Pipe Products Image
                            </Typography>

                            <Field
                              name="pipe_products_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"pipe_products_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="pipe_products_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Hot Rolled Round
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="hot_rolled_round"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="hot_rolled_round" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Pipe Products Image
                            </Typography>

                            <Field
                              name="hot_rolled_round_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"hot_rolled_round_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="hot_rolled_round_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Stainless Steel
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="stainless_steel"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="stainless_steel" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Stainless Steel Image
                            </Typography>

                            <Field
                              name="stainless_steel_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"stainless_steel_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                            <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="stainless_steel_image" />
                            </Box>
                          </div>
                        </Box>

                        <Box mt={10}>
                          <Typography
                            fontStyle="bold"
                            fontWeight={600}
                            fontSize={16}
                          >
                            {" "}
                            Ferro Alloys
                          </Typography>
                          <Box mt={2}>
                            <Field
                              name="ferro_alloys"
                              render={({ field, form }) => (
                                <TextEditor
                                  name={field.name}
                                  value={field.value}
                                  onChange={setFieldValue}
                                />
                              )}
                            />
                            <Box mt={7} color="red" fontSize={18}>
                              <ErrorMessage name="ferro_alloys" />
                            </Box>
                          </Box>
                          <div className="col-md-6" style={{ paddingTop: 100 }}>
                            <Typography
                              fontStyle="bold"
                              fontWeight={300}
                              fontSize={16}
                            >
                              Ferro Alloys Image
                            </Typography>

                            <Field
                              name="ferro_alloys_image"
                              label="Upload Image"
                              render={({ field, form }) => (
                                <ImageUpload
                                  id={values && values.id}
                                  name={"ferro_alloys_image"}
                                  value={field.value}
                                  onChange={setFieldValue}
                                  imageFolderPath={"exports_data"}
                                />
                              )}
                            />
                             <Box mt={2} color="red" fontSize={18}>
                              <ErrorMessage name="ferro_alloys_image" />
                            </Box>
                          </div>
                        </Box>

                        <div className="col-md-12 mt-3">
                          <button
                            type="submit"
                            className="btn btn-primary me-3"
                          >
                            <span className="indicator-label">Save</span>
                          </button>

                          <button type="reset" className="btn btn-light me-3">
                            Cancel
                          </button>
                        </div>
                        {/* </div> */}
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <br />
        <br />
      </div>
    </div>
  );
};

export default ExportDetailsPage;
